// src/services/kokam/temporalKokamParticipanteService.js

import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/kokam/participantes";

/**
 * @param {File} file
 */
export const subirExcelParticipantes = async (file) => {
  try {
    const formData = new FormData();
    formData.append("archivo", file);

    const response = await axios.post(
      `${baseUrl}${endpoint}/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error("Error subiendo Excel de participantes:", error);
    throw error;
  }
};